import { MarkovRedistribution } from "server/models"

export interface MarkovRedistributionProps {
    redistributionId: number
}

export type MarkovRedistributionValidation = { [key in keyof MarkovRedistribution]?: string}

export interface MarkovRedistributionState {
    redistributions: MarkovRedistribution[]
    redistributionSelected: MarkovRedistribution
    redistributionEdit: MarkovRedistribution

    reloadList: boolean
    reloadEdit: boolean
}

export const MARKOV_REDISTRIBUTIONS = "MARKOV_REDISTRIBUTIONS"
export const MARKOV_REDISTRIBUTION_SELECTED = "MARKOV_REDISTRIBUTION_SELECTED"
export const MARKOV_REDISTRIBUTION_EDIT = "MARKOV_REDISTRIBUTION_EDIT"

export const MARKOV_REDISTRIBUTION_RELOAD_LIST = "MARKOV_REDISTRIBUTION_RELOAD_LIST"
export const MARKOV_REDISTRIBUTION_RELOAD_EDIT = "MARKOV_REDISTRIBUTION_RELOAD_EDIT"
